var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var RelatedObjects = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("g", __assign({ id: "Icon/Related objects" }, { children: _jsx("path", { id: "Vector", d: "M5.56595 9.83057L5.56595 14.4785C5.56639 14.6217 5.56667 14.7995 5.56685 14.9995C5.56829 16.6563 5.40909 18 7.06595 18H10.3945M9.6592 15.679L11.9978 18.0176L9.66138 20.3588M4.5 3H19.5C20.3284 3 21 3.33579 21 3.75V8.25C21 8.66421 20.3284 9 19.5 9H4.5C3.67157 9 3 8.66421 3 8.25V3.75C3 3.33579 3.67157 3 4.5 3ZM16.0565 15H20.5043C20.7781 15 21 15.3358 21 15.75V20.25C21 20.6642 20.7781 21 20.5043 21H16.0565C15.7828 21 15.5609 20.6642 15.5609 20.25V15.75C15.5609 15.3358 15.7828 15 16.0565 15Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }))] })));
});
